import React from 'react';
import { Sun, Moon } from 'lucide-react';

type BoardTheme = 'light' | 'dark';

interface BoardThemeSwitchProps {
  theme: BoardTheme;
  onToggle: () => void;
}

const BoardThemeSwitch: React.FC<BoardThemeSwitchProps> = ({ theme, onToggle }) => {
  return (
    <button
      onClick={onToggle}
      aria-label="Toggle dark mode"
      className="
        flex items-center gap-2 px-3 py-1 rounded-lg transition-all duration-200
        data-[theme=light]:bg-gray-100 data-[theme=light]:text-gray-700 data-[theme=light]:hover:bg-gray-200
        data-[theme=dark]:bg-gray-700 data-[theme=dark]:text-gray-300 data-[theme=dark]:hover:bg-gray-600
      "
      data-theme={theme}
    >
      {theme === 'light' ? (
        <>
          <Sun size={16} />
          <span className="text-sm font-medium">Light</span>
        </>
      ) : (
        <>
          <Moon size={16} />
          <span className="text-sm font-medium">Dark</span>
        </>
      )}
    </button>
  );
};

export default BoardThemeSwitch;
